const InformacionIcon = () => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="32"
        cy="32"
        r="32"
        transform="rotate(-180 32 32)"
        fill="var(--color-latex10)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.9972 17.7812C30.0335 17.7812 28.4416 16.1894 28.4416 14.2257C28.4416 12.262 30.0335 10.6701 31.9972 10.6701C33.9609 10.6701 35.5527 12.262 35.5527 14.2257C35.5527 16.1894 33.9609 17.7812 31.9972 17.7812Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.9972 53.3335C30.0335 53.3335 28.4416 51.7416 28.4416 49.7779L28.4416 28.4446C28.4416 26.4809 30.0335 24.8891 31.9972 24.8891C33.9609 24.8891 35.5527 26.4809 35.5527 28.4446L35.5527 49.7779C35.5527 51.7416 33.9609 53.3335 31.9972 53.3335Z"
        fill="white"
      />
    </svg>
  );
};

export default InformacionIcon;
